module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-MdIt.8f330d5.woff2";